import React, { Children, useEffect, useState } from "react";
import {
  useFieldArray,
  useFormContext,
  useFormState,
  useWatch,
} from "react-hook-form";
import { Button } from "react-bootstrap";
import "./NFormTable.css";

export interface IProps {
  children?: React.ReactNode;
  fieldArray?: string | any;
  handlyApplyChanges?: ()=>void;
  responseData?: any;
  employeeResponseData?:any;
  handlyeEmployeePayrollChanges?:()=>void;
  onFieldValueChanged?: (
    fieldName: string,
    index: number,
    oldValue: any,
    newValue: any
  ) => void;
  emptyMessage?: string;
}

export const NFSalaryAccrualsTable = ({
  children,
  handlyApplyChanges,
  handlyeEmployeePayrollChanges,
  responseData,
  fieldArray,
  employeeResponseData,
  onFieldValueChanged,
  emptyMessage = "",
}: IProps) => {
  const arrayChildren = Children.toArray(children);

  const {
    register,
    control,
    watch,
    formState: { errors },
    getValues,
    setValue,
    resetField,
  } = useFormContext();
  const { dirtyFields } = useFormState();
  const { fields, append, remove } = useFieldArray({
    control,
    name: fieldArray,
  });
  const watchFieldArray = watch(fieldArray);

  const controlledFields = fields.map((field, index) => {
    return {
      ...field,
      ...watchFieldArray[index],
    };
  });

  const handleAddNewRow = () => {
    append({
      lineNo: fields.length + 1,
    });
  };

  const handleRemoveRow = (index: number) => {
    remove(index);
    const newFieldArray = getValues(fieldArray);
    newFieldArray.forEach((field: any, index: number) => {
      if (field.lineNo !== index + 1) {
        field.lineNo = index + 1;
      }
    });
    setValue(fieldArray, newFieldArray);
  };

  return (
    <>
      <div className="w-100">
        <div style={{ width: "250px" }}>
          <Button
            variant=""
            className="btn btn-sm btn-primary mb-3"
            onClick={handleAddNewRow}
          >
            Add Employee
          </Button>
          <Button
            onClick={handlyApplyChanges}
            variant=""
            className="btn btn-sm btn-primary mb-3 ms-2"
          >
            Fill With
          </Button>
          <Button
            onClick={handlyeEmployeePayrollChanges}
            variant=""
            className="btn btn-sm btn-primary mb-3 ms-2"
          >
            Fill Accrual/Deductions
          </Button>
        </div>
        <div className={"scroll"}>
          <table className={"table table-sm table-hover"}>
            <thead>
              <tr>
                {arrayChildren &&
                  arrayChildren.map((field: any, index) => {
                    return (
                      <th key={index} className="fw-normal">
                        {field.props?.title}
                      </th>
                    );
                  })}
                {/* <th className="fw-normal">Actions</th> */}
              </tr>
            </thead>
            <tbody>
              {controlledFields.map((field, index) => {
                return (
                  <tr key={index}>
                    {arrayChildren &&
                      arrayChildren.map((column: any, columnIndex) => {
                        if (column.props.required === true) {
                          register(
                            `${fieldArray}[${index}].${column.props.fieldName}`,
                            { required: true }
                          );
                        }

                        return (
                          <td style={{ margin: "0 auto" }} key={columnIndex}>
                            {React.cloneElement(column, {
                              fieldName: `${fieldArray}[${index}].${column.props.fieldName}`,
                              showBorder: false,
                              title: undefined,
                              index: index,
                              value: field[column.props.fieldName],
                              tableName: fieldArray,
                              tableFieldName: column.props.fieldName,
                            })}
                          </td>
                        );
                      })}

                    <td className={"text-center"} style={{ width: 50 }}>
                      <a
                        href={"#"}
                        className={"text-danger"}
                        onClick={() => handleRemoveRow(index)}
                      >
                        <i className="fa-solid fa-trash-can"></i>
                      </a>
                    </td>
                  </tr>
                );
              })}
            </tbody>
            <div>

            {responseData.map((item: any, index:number) => {
              return <div key={index}>
                <p className="ms-3">{item.firstName} {item.lastName}</p>
              </div>;
            })}
            </div>
            <div>
            {employeeResponseData.map((item: any, index:number) => {
              return <div key={index}>
                <p className="ms-3">{item.employeeId}</p>
              </div>;
            })}
            </div>
          </table>
          {controlledFields.length === 0 && (
            <div className={"w-100 text-center h5 pt-3"}> {emptyMessage} </div>
          )}
        </div>
      </div>
    </>
  );
};
